// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf, enumOf, recordOf, maybe } from "@altostra/type-validations";
import { string, boolean, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

import { CurrentsDestination } from "./types";

export const isCurrentsDestination = enumOf<CurrentsDestination>(
  CurrentsDestination.S3, // This comes first because "Amazon S3" comes before "Amplitude" for English localization
  CurrentsDestination.Adobe,
  CurrentsDestination.Amplitude,
  CurrentsDestination.AzureBlob,
  CurrentsDestination.CustomHttp,
  CurrentsDestination.Eventbridge,
  CurrentsDestination.GCS,
  CurrentsDestination.Heap,
  CurrentsDestination.Mixpanel,
  CurrentsDestination.MParticle,
  CurrentsDestination.RudderStack,
  CurrentsDestination.Segment,
  CurrentsDestination.Shopify,
  CurrentsDestination.Tealium,
  CurrentsDestination.TreasureData
);

export const isIntegrationsCurrentsIntegrationDataIdResult = objectOf({
  id: string,
  app_group_id: string,
  company_id: string,
  deleted: boolean,
  enabled: boolean,
  throttled: boolean,
  name: string,
  track_user_behavior_events: boolean,
  track_user_profile_events: boolean,
  integration_type: isCurrentsDestination,
  service_type: string,
  user_alias_enabled: anyOf(nullOrUndefined, boolean),
  anon_user_alias_enabled: anyOf(nullOrUndefined, boolean),
  alias_label: anyOf(nullOrUndefined, string),
  anon_alias_label: anyOf(nullOrUndefined, string),
  event_type_configs: recordOf({ key: string, value: boolean }),
  event_field_transformations: recordOf({ key: string, value: boolean }),
  contact_email: anyOf(nullOrUndefined, string),
  auth_type: maybe(number),
  access_key_id: anyOf(nullOrUndefined, string),
  role_arn: maybe(string),
  external_id: maybe(string),
  bucket_name: maybe(string),
  bucket_region: maybe(string),
  topics_dir: maybe(string),
  export_anonymous_user_events: maybe(boolean),
  account_id: maybe(string),
  sse_type: anyOf(nullOrUndefined, string),
  sse_key_id: anyOf(nullOrUndefined, string),
  is_sse: maybe(boolean),
  created: objectOf({
    time: number,
    name: string,
    d_id: maybe(string),
  }),
  last_edit: objectOf({
    time: number,
    name: string,
    d_id: maybe(string),
  }),
  broken_creds: boolean,
  total_currents_integrations_entitlements: number,
  used_currents_integrations_entitlements: number,
  total_user_behavior_entitlements: number,
  used_user_behavior_entitlements: number,
  total_user_attributes_entitlements: number,
  used_user_attributes_entitlements: number,
});
